export const NOTIFICATION_CHANNELS = [
  { key: "in_app", label: "In-app" },
  { key: "email", label: "Email" },
  { key: "google_chat", label: "Chat" },
];

export const NOTIFICATION_MATRIX = [
  {
    group: "Comments",
    resourceType: "comment",
    events: [
      { event: "comment.mention", label: "Mentions" },
      { event: "comment.reply", label: "Replies to your comments" },
    ],
  },
  {
    group: "Orders",
    resourceType: "order",
    events: [
      { event: "order.created", label: "Order Created" },
      { event: "order.deleted", label: "Order Deleted" },
    ],
  },
  {
    group: "Work Orders",
    resourceType: "work_order",
    events: [
      { event: "work_order.created", label: "Work Order Created" },
      { event: "work_order.completed", label: "Work Order Completed" },
      { event: "work_order.arrived_at", label: "Work Order Arrived at Watched Station(s)" },
      { event: "work_order.deleted", label: "Work Order Deleted" },
    ],
  },
  {
    group: "Parts",
    resourceType: "part",
    events: [
      { event: "part.created", label: "Part Created" },
      { event: "part.deleted", label: "Part Deleted" },
      {
        event: "part.details_changed",
        label: "Part Details Changed",
        helper: "Manager, status, price, quote, or metal.",
      },
    ],
  },
  {
    group: "Shipments",
    resourceType: "shipment",
    events: [
      { event: "shipment.created", label: "Shipment Created" },
      { event: "shipment.deleted", label: "Shipment Deleted" },
      { event: "shipment.shipped", label: "Shipment Shipped" },
    ],
  },
];
